import { combineReducers, Reducer } from 'redux';

import * as types from './chart.types';
import * as constants from './chart.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IChartPageState = {
  nodeIds: [],
  refreshChart: 0,
  versions: [],
  selectedChartId: null,
  isDraftSelected: false,
};

const chartNodesReducer: Reducer<types.IChartPageState['nodeIds'], types.IStoreChart | types.IClearChart> = (
  state = initialState.nodeIds,
  action,
) => {
  if (isActionOfType<types.IStoreChart>(action, constants.STORE_CHART)) {
    return action.payload;
  } else if (isActionOfType<types.IClearChart>(action, constants.CLEAR_CHART)) {
    return initialState.nodeIds;
  }

  return state;
};

const refreshChartReducer: Reducer<
  types.IChartPageState['refreshChart'],
  types.IRefreshChart | types.IClearRefreshChart
> = (state = initialState.refreshChart, action) => {
  if (isActionOfType<types.IRefreshChart>(action, constants.REFRESH_CHART)) {
    return action.payload;
  } else if (isActionOfType<types.IClearRefreshChart>(action, constants.CLEAR_REFRESH_CHART)) {
    return initialState.refreshChart;
  }

  return state;
};

const chartVersionsReducer: Reducer<
  types.IChartPageState['versions'],
  types.IStoreChartVersions | types.IClearChartEditState
> = (state = initialState.versions, action) => {
  if (isActionOfType<types.IStoreChartVersions>(action, constants.STORE_CHART_VERSIONS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearChartEditState>(action, constants.CLEAR_CHART_EDIT_STATE)) {
    return initialState.versions;
  }

  return state;
};

const selectedChartIdReducer: Reducer<
  types.IChartPageState['selectedChartId'],
  types.ISetSelectedChartId | types.IClearChartEditState
> = (state = initialState.selectedChartId, action) => {
  if (isActionOfType<types.ISetSelectedChartId>(action, constants.SET_SELECTED_CHART_ID)) {
    return action.payload;
  } else if (isActionOfType<types.IClearChartEditState>(action, constants.CLEAR_CHART_EDIT_STATE)) {
    return initialState.selectedChartId;
  }

  return state;
};

const isDraftSelectedReducer: Reducer<
  types.IChartPageState['isDraftSelected'],
  types.ISetDraftSelected | types.IClearChartEditState
> = (state = initialState.isDraftSelected, action) => {
  if (isActionOfType<types.ISetDraftSelected>(action, constants.SET_DRAFT_SELECTED)) {
    return action.payload;
  } else if (isActionOfType<types.IClearChartEditState>(action, constants.CLEAR_CHART_EDIT_STATE)) {
    return initialState.isDraftSelected;
  }

  return state;
};

export const chartPageReducer: Reducer<types.IChartPageState, types.IChartPageAction> = combineReducers({
  nodeIds: chartNodesReducer,
  refreshChart: refreshChartReducer,
  versions: chartVersionsReducer,
  selectedChartId: selectedChartIdReducer,
  isDraftSelected: isDraftSelectedReducer,
});
